var Config = function ($stateProvider, $urlRouterProvider, SettingsConstants, RouteConstants,
                       apiServiceProvider, StatesHistoryProvider, $provide, $httpProvider,
                       CheckConnectionProvider, ssWidgetService,
                       sdAnalyticsServiceProvider, $locationProvider, $sceDelegateProvider) {

    if (window.appSettings?.notWidget) {
        console.debug("$locationProvider.html5Mode = true");
        $locationProvider.html5Mode(true);
    }

    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        '**'
    ]);

    //decorate $log service to handle logging depending on environment mode.
    $provide.decorator('$log', ['$delegate', function ($delegate) {
        //ToDo API need specify environment variable in appSettings.
        var developmentMode = _.some(['localhost', 'oss-ngx.ci.labs', 'oss.dfx.local'], function (el) {
            return _.includes(_.toLower(appSettings.serverUrl), el);
        });

        var originals = {};
        var methods = ['info', 'debug', 'warn', 'error', 'log'];

        angular.forEach(methods, function (method) {
            originals[method] = $delegate[method];
            $delegate[method] = function () {
                if (developmentMode) {
                    var args = [].slice.call(arguments);
                    // var timestamp = new Date().toTimeString();
                    // args[0] = [timestamp.substring(0, 8), ' ', args[0]].join('');
                    originals[method].apply(null, args);
                }
            };
        });

        return $delegate;
    }]);

    // function, previous state service generator. It is using to have access
    // to previous state in the each state controller
    var previousStateService = function ($state, SettingsConstants) {
        var currentStateData = {
            name: $state.current.name,
            params: $state.params,
            url: $state.href($state.current.name, $state.params)
        };
        return currentStateData;
    };
    previousStateService.$inject = ['$state', 'SettingsConstants'];
    // decorate state service to disable url changing required to widget realization
    $provide.decorator('$state', ['$delegate', 'authToken', '$log', function ($delegate, authToken, $log) {
        var swap = function (originFn) {
            return function () {
                var args = Array.prototype.slice.call(arguments);
                if (!args[0]) {
                    throw new Error('It is required to set state name');
                }
                args[1] = args[1] ? args[1] : {};
                args[2] = args[2] ? args[2] : {};
                args[2].location = false;
                return authToken.resolveToken(window.appSettings.authUrl).then(function () {
                    return originFn.apply(null, args);
                }).catch(function (err) {
                    $log.error('Could not get authentication token');
                    $log.error(err);
                });
            };
        };

        $delegate.go = swap($delegate.go);
        return $delegate;
    }]);
    // load states
    angular.forEach(RouteConstants, function (state, key) {
        const templateUrl = state.templateUrl;
        state = angular.extend(state, {
            resolve: {
                previousState: previousStateService
            },
            templateUrl: function () {
                return window['ossTemplateUrlProvider'] ? window['ossTemplateUrlProvider'](templateUrl) : templateUrl;
            }
        });
        $stateProvider.state(key, state);
    });
    // init states caching services
    StatesHistoryProvider.excludeStates([
        'bookappointment',
        'createcustomer'
    ]);
    // set http queryes interseptor for using backend emulation
    // in production version myst be false
    apiServiceProvider.useHttpBackendMock(SettingsConstants.APP_HTTP_BACKEND);
    // set catalog url as entrypoint of API
    apiServiceProvider.setCatalogUrl(window.appSettings.serverUrl + '/catalog');

    // add http requests interceptor
    $httpProvider.interceptors.push('httpInterceptor');
    $httpProvider.interceptors.push('apiResponseTimeStatisticsInterceptor');

    // http interceptor for generic api errors
    $httpProvider.interceptors.push('genericApiErrorInterceptor');

    //set current culture for requests
    var currentCulture = window.appSettings.currentCulture;
    $httpProvider.defaults.headers.common['Accept-Language'] = currentCulture;

    //configure moment.js date & time locale
    moment.updateLocale('en', {
        longDateFormat: {
            LT: 'hh:mm a',
            LL: 'dddd MMMM D, YYYY',
            LLLL: 'dddd MMMM D, YYYY hh:mm a'
        }
    });

    moment.updateLocale('fr-ca', {
        longDateFormat: {
            LL: '[le] dddd D MMMM YYYY',
            LLLL: '[le] dddd D MMMM YYYY HH:mm'
        }
    });

    moment.updateLocale('es', {
        longDateFormat: {
            LT: 'hh:mm a',
            LL: 'dddd MMMM D, YYYY',
            LLLL: 'dddd MMMM D, YYYY hh:mm a'
        }
    });

    currentCulture = _.toLower(currentCulture) === 'es-mx' ? 'es' : currentCulture;

    var momentLocale = _.includes(moment.locales(), _.toLower(currentCulture)) ? currentCulture : 'en';
    moment.locale(momentLocale);

    CheckConnectionProvider.setAjaxUsing(false);


    ssWidgetService.init(window.appSettings.diagnosticsSheetsUrl, window.appSettings.diagnosticsSheetsEnabled);
    /**
     * SYMPTOM SURVEY WIDGET CONFIGURATION END
     */

    sdAnalyticsServiceProvider.setProviderName('DFX ONLINE SERVICE SCHEDULER');
};

Config.$inject = ['$stateProvider', '$urlRouterProvider', 'SettingsConstants', 'RouteConstants',
    'apiServiceProvider', 'StatesHistoryProvider', '$provide', '$httpProvider',
    'CheckConnectionProvider', 'ssWidgetServiceProvider', 'sdAnalyticsServiceProvider',
    '$locationProvider', '$sceDelegateProvider']

module.exports = Config;
